import { render, staticRenderFns } from "./ArchiveAccountsPayable.vue?vue&type=template&id=1e64044b&"
import script from "./ArchiveAccountsPayable.vue?vue&type=script&lang=js&"
export * from "./ArchiveAccountsPayable.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveAccountsPayable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveAccountsPayable.vue"
export default component.exports